"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _eventTargetShim = _interopRequireWildcard(require("./external/event-target-shim"));

var SpeechSynthesisAudioStreamUtterance = /*#__PURE__*/function (_EventTarget) {
  (0, _inherits2.default)(SpeechSynthesisAudioStreamUtterance, _EventTarget);

  function SpeechSynthesisAudioStreamUtterance(audioStream) {
    var _this;

    (0, _classCallCheck2.default)(this, SpeechSynthesisAudioStreamUtterance);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SpeechSynthesisAudioStreamUtterance).call(this));

    if (audioStream && !(audioStream.format && audioStream.streamReader)) {
      throw new Error('The first argument must be a Cognitive Services audio stream.');
    }

    _this.audioStream = audioStream;
    return _this;
  }

  return SpeechSynthesisAudioStreamUtterance;
}(_eventTargetShim.default);

(0, _eventTargetShim.defineEventAttribute)(SpeechSynthesisAudioStreamUtterance, 'boundary');
(0, _eventTargetShim.defineEventAttribute)(SpeechSynthesisAudioStreamUtterance, 'end');
(0, _eventTargetShim.defineEventAttribute)(SpeechSynthesisAudioStreamUtterance, 'error');
(0, _eventTargetShim.defineEventAttribute)(SpeechSynthesisAudioStreamUtterance, 'start');
var _default = SpeechSynthesisAudioStreamUtterance;
exports.default = _default;